import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { routes } from "../../../../config/utilities/utils.constant";

export const LookingToLaunchWebsite = () => {
  return (
    <section className=" bg-[#f3ebfa] py-20 space-y-8 px-5">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] text-center  font-bold text-dark font-butler"
      >
        Looking to launch your website?{" "}
      </motion.h2>

      <div className="container flex flex-col justify-center items-center  space-y-8 ">
        <div className="space-y-4">
          <p className="text-center text-xl  ">
            Whether you are a local startup in the Fairfax County or a growing
            national brand, our web development services eliminate your
            technical hurdles, allowing you to focus on what matters most:
            running your business and engaging your customers.
          </p>
          <p className="text-center text-xl  ">
            {" "}
            Get in touch with us for a quick and free consultation to design a
            new website or help with an existing one.
          </p>
        </div>
        <div className="z-10">
          <Link
            to={routes.CONTACTUS}
            aria-label="Internal link to Contact Us page"
          >
            <button
              title="Schedule Discovery Call"
              className="  px-6 py-4 bg-[#FFC067] text-dark font-bold rounded shadow text-base  md:text-lg transition hover-filled  "
            >
              Schedule Discovery Call{" "}
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};
